import TESegmentedGroup from './TESegmentedGroup';

export default TESegmentedGroup;
